export const formatDate = (date) => {
  return date.format("YYYY-MM-DD");
};
